import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import {
  AccountInfo,
  ForgotPasswordViewModel,
  LoginInfo,
  LoginResult,
  SocialUserLoginInfo,
  UserProfile,
  MagicLinkViewModel
} from '../models/auth-data.model';
import { finalize, tap } from 'rxjs/operators';
import { SocialUser } from 'angularx-social-login';
import { ApiService } from './api.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isloggedin: boolean = false;
  private vistekUrl: string;
  public get VistekUrl(): string {
    return this.vistekUrl;
  }
  private userProfileSubject = new BehaviorSubject<UserProfile>(null);
  public get UserProfileSubject(): BehaviorSubject<UserProfile> {
    return this.userProfileSubject;
  }

  private loginSubject = new BehaviorSubject<LoginInfo>(null);
  private accountWaitingSubject = new BehaviorSubject<boolean>(false);
  public get AccountWaitingSubject(): BehaviorSubject<boolean> {
    return this.accountWaitingSubject;
  }

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private apiService: ApiService,
    private cookieService: CookieService
  ) {
    this.vistekUrl = this.appConfigService.vistekUrl;
  }

  //cart/login
  public login(loginInfo: LoginInfo): Observable<LoginResult> {
    let targetUrl = `${this.vistekUrl}/cart/login?returnUrl=&mode=ajax`;
    return this.http.patch<LoginResult>(targetUrl, loginInfo, { headers: this.apiService.xsrfHeader }).pipe(
      tap((data) => {
        this.isloggedin = true;
        this.userProfileSubject.next(data.User);
      })
    );
  }

  public externallogin(socialUser: SocialUser): Observable<LoginResult> {
    let loginInfo = new SocialUserLoginInfo();
    loginInfo.ProviderKey = socialUser.id;
    loginInfo.LoginProvider = socialUser.provider;
    loginInfo.ProviderDisplayName = socialUser.provider;
    loginInfo.Name = socialUser.name;
    loginInfo.FirstName = socialUser.firstName;
    loginInfo.LastName = socialUser.lastName;
    loginInfo.Email = socialUser.email;
    loginInfo.AuthToken = socialUser.authToken;
    loginInfo.IdToken = socialUser.idToken;
    loginInfo.IsPersistent = true;
    let targetUrl = `${this.vistekUrl}/cart/externallogin`;

    return this.http.patch<LoginResult>(targetUrl, loginInfo, { headers: this.apiService.xsrfHeader }).pipe(
      tap((data) => {
        //console.log(data);
        this.isloggedin = true;
        this.userProfileSubject.next(data.User);
        //localStorage.setItem('userData', JSON.stringify(data.user));
      })
    );
  }

  public logout() {
    let targetUrl = `${this.vistekUrl}/cart/logout`;
    return this.http.patch<any>(targetUrl, null, { headers: this.apiService.xsrfHeader }).pipe(
      tap((result) => {
        if (result.sucess) {
          this.isloggedin = false;
          this.userProfileSubject.next(null);
          //localStorage.setItem('userData', null);
        }
      })
    );
  }

  //cart/login
  public getUserProfile(): Observable<UserProfile> {
    const userProfilerStr = this.cookieService.get('LoggedInUserProfile'); // To Get Cookie
    let userProfile = null;
    if (!!userProfilerStr) {
      let user = JSON.parse(userProfilerStr);
      let userProfile = new UserProfile();
      userProfile.Email = user.email;
      userProfile.FirstName = user.firstName;
      userProfile.LastName = user.lastName;
      userProfile.UserName = user.userName;
      this.isloggedin = true;
      this.userProfileSubject.next(userProfile);
    } else {
      this.isloggedin = false;
    }
    return of(userProfile);
  }

  //cart/login
  public forgotpassword(forgotPasswordInfo: ForgotPasswordViewModel) {
    let targetUrl = `${this.vistekUrl}/cart/ngforgotpassword`;
    return this.http.post<any>(targetUrl, forgotPasswordInfo, { headers: this.apiService.xsrfHeader }).pipe(
      tap((data) => {
        //console.log(data);
      })
    );
  }

  public magicLink(magicLinkViewModel: MagicLinkViewModel) {
    let targetUrl = `${this.vistekUrl}/cart/magic-link`;
    return this.http.post<any>(targetUrl, magicLinkViewModel, { headers: this.apiService.xsrfHeader }).pipe(
      tap((data) => {
       // console.log(data);
      })
    );
  }

  //cart/login
  public signup(accountInfo: AccountInfo): Observable<LoginResult> {
    let targetUrl = `${this.vistekUrl}/cart/registeraccount?returnUrl=&mode=ajax`;
    return this.http.post<LoginResult>(targetUrl, accountInfo, { headers: this.apiService.xsrfHeader }).pipe(
      tap((data) => {
        console.debug('signup result is', data);

        if (data.Success === true) {
          this.isloggedin = true;
          this.userProfileSubject.next(data.User);
        }
      })
    );
  }

  public getSavedLoginInfo(): Observable<LoginInfo> {
    const targetUrl = `${this.vistekUrl}/cart/savedLoginInfo`;
    return this.http.get<LoginInfo>(targetUrl);
  }

  public getEmailExists(email: string): Observable<boolean> {
    const targetUrl = `${this.vistekUrl}/api/cart/accountexists`;
    var formData = new FormData();
    formData.append('email', email);
    return this.http.post<boolean>(targetUrl, formData, { headers: this.apiService.xsrfHeader }).pipe(
      tap((data) => {
       // console.log(data);
      })
    );
  }
}
